<div class="profile-box-area p-0 mb-4">
    <div class="profile-box-img mr-2">
       
        <img *ngIf="staffInfo.profileUrl!==' '" src={{staffInfo.profileUrl}} onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';" alt="profile-image"/>
        <img *ngIf="staffInfo.profileUrl===' '" src="assets/images/person-ic.jpg" onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';" alt="profile-image"/>
    </div>
    <div class="profile-box-info">
        <h3>{{staffInfo.name}}</h3>
        <!-- <h5>{{staffInfo.branchName}}, {{staffInfo.branchLocation}}</h5> -->
        <h5 class="pb-1">{{staffInfo.branchName}}</h5>

        <label class="d-flex align-items-center w-100 icon-with-label pb-1">
            <span class="material-icons green_text mr-2">
                email
            </span>
           <span class="mail-text-wrap" 
           [matTooltip]="staffInfo.emailId"
           matTooltipPosition="above">
           {{staffInfo.emailId}}
          </span>
        </label>
        <label class="d-flex align-items-center w-100 icon-with-label">
            <span class="material-icons green_text mr-2">
                phone
            </span>
            <!-- {{staffInfo.phoneNo}} -->
            {{formatPhone((staffInfo?.phoneCode), staffInfo?.phoneNo)}}
        </label>
    </div>
</div>